import { api, api_nexus } from './api';

export interface GetBanksProps {
  label: string;
  value: string;
}

async function getBanks(query?: string): Promise<any> {
  const params = new URLSearchParams();

  if (query) {
    params.append('q', query);
  }

  const res = await api_nexus.get(`/banks${query && `?${params.toString()}`}`);

  const data = res.data?.data || [];

  return data;
}

async function createUSBank(bankData: any): Promise<any> {
  const res = await api.post('/v1/usd-bank-accounts', bankData);
  return res.data;
}

export const GetBanksService = { getBanks, createUSBank };
